import { MenuItem } from 'primeng/api';

export interface FooterMenu {
  category: string;
  items: Array<MenuItem>;
}

export const footerMenuConfig: (baseUrl: string) => Array<FooterMenu> = (baseUrl) => [
  {
    category: 'Soluții',
    items: [
      {
        label: 'Sunt Angajat',
        url: `${baseUrl}/angajat/`,
      },
      {
        label: 'Sunt Angajator',
        url: `${baseUrl}/angajator/`,
      },
      {
        label: 'Cum ne comparăm cu alții',
        url: `${baseUrl}/cum-ne-comparam-cu-altii/`,
      },
    ],
  },
  {
    category: 'Parteneri',
    items: [
      {
        label: 'Allianz-Țiriac Pensii Private',
        url: `${baseUrl}/parteneri/`,
      },
    ],
  },
  {
    category: 'Resurse',
    items: [
      {
        label: 'Articole',
        url: `${baseUrl}/blog/`,
      },
      {
        label: 'Ghiduri de pensii facultative',
        url: `${baseUrl}/ghiduri-de-pensii-facultative/`,
      },
      {
        label: 'Ghid de plată al contribuțiilor',
        url: `${baseUrl}/ghid-de-plata-a-contributiilor/`,
      },
      {
        label: 'Tutoriale',
        url: `${baseUrl}/tutoriale/`,
      },
      {
        label: 'Documente',
        url: `${baseUrl}/documente/`,
      },
    ],
  },
  {
    category: 'Companie',
    items: [
      {
        label: 'Despre iPensii',
        url: `${baseUrl}/despre-noi/`,
      },
      {
        label: 'Protecția datelor și aspecte legale',
        url: `${baseUrl}/protectia-datelor-si-aspecte-legale/`,
      },
      {
        label: 'Feed iPensii în presă',
        url: `${baseUrl}/feed-ipensii-in-presa/`,
      },
      {
        label: 'Kit de presă',
        url: `${baseUrl}/kit-de-presa/`,
      },
    ],
  },
  {
    category: 'Contact',
    items: [
      {
        label: 'hello@ipensii.ro',
        url: 'mailto:hello@ipensii.ro',
        icon: 'pi pi-envelope',
      },
      {
        label: 'iPensii',
        url: `${baseUrl}/kit-de-presa/`,
        icon: 'pi pi-linkedin',
      },
      {
        label: 'iPensii',
        url: `${baseUrl}/kit-de-presa/`,
        icon: 'pi pi-instagram',
      },
      {
        label: 'iPensii',
        url: `${baseUrl}/kit-de-presa/`,
        icon: 'pi pi-facebook',
      },
    ],
  },
];

export const authorizationText =
  'Autorizat de către Autoritatea de Supraveghere Financiară în baza Deciziei nr. 1001 din data de 25.09.2023 și înscris în Registrul brokerilor de pensii facultative (Pilonul III): sub nr. cod AMJ-RO-48326775';

export const ipensiiDetailText = `IPENSII BROKER DE PENSII PRIVATE
   Municipiul Timișoara, str. Moise Doboșan, nr. 5, SAD 2, SP. 12, județul Timiș, cod poștal 300406
   E-mail: hello@ipensii.ro, www.ipensii.ro
   Registrul Comerțului: J35/2269/2023, CUI: 48314318, Capital social: 31250 lei`;
